import { advertisingFiltersSelector, advertisingFiltersSelector2 } from "core/dataConstants";
import { createError } from "core/exceptions";
import { createSagasForBasicCall } from "core/sagas";
import { cloneDeep } from "lodash";
import * as log from "loglevel";
import { call, debounce, put, select, takeLatest } from "redux-saga/effects";
import AdvertisingService from "services/advertisingService";
import { detailsIdSelector } from "../../../core/dataConstants";
import { actions, advFormDefaultValues } from "./formActions";
import {
    formatAdvToEdit,
    fromExitingAdv,
    getAdvFormCallback,
    getFormStateSelector,
    getNewAdvertising,
    selectFromDetails,
    selectedFilmRelease,
} from "./sagaHelpers";
import {reviewStatusTypesSelector, usersSelector} from "components/global/logic/actions";

export function* filterAdvertising() {
    try {
        const advertising = yield select(advertisingFiltersSelector);
        log.debug("advertising", advertising);
        const filters = yield select(advertisingFiltersSelector2);
        log.debug("searching advertising", filters);
        const response = yield call(AdvertisingService.getAll, filters);
        yield put(actions.CHANGE_FORM.success({ data: response.data }));
    } catch (e) {
        log.error(e);
        yield put(actions.CHANGE_FORM.failed(null, createError(e)));
    }
}

export function* addAdvertising() {
    try {
        const newAdv = yield select(getNewAdvertising);
        const refreshViewPage = cloneDeep(newAdv.refreshViewPage);
        log.debug("adding new adv", newAdv);
        if (refreshViewPage) {
            delete newAdv.refreshViewPage;
        }
        const callback = yield select(getAdvFormCallback);
        const adv = yield call(AdvertisingService.createAdv, newAdv);
        const redirectId = refreshViewPage ? adv.data.id : null;
        callback(redirectId);
        yield put(actions.ADD_ADV.success());
    } catch (e) {
        log.debug(e);
        yield put(actions.ADD_ADV.failed(null, createError(e)));
    }
}
export function* editAdvertising() {
    try {
        const newAdv = yield select(getNewAdvertising);
        const fromDetails = yield select(selectFromDetails);
        const { id } = yield select(getFormStateSelector);
        const callback = yield select(getAdvFormCallback);
        const response = yield call(AdvertisingService.editAdv, { ...newAdv, id });
        callback();
        yield put(actions.EDIT_ADV.success());
        if (fromDetails) {
            yield put(actions.VIEW_ADV.success({ data: response.data }));
        }
    } catch (e) {
        log.error(e);
        yield put(actions.EDIT_ADV.failed(null, createError(e)));
    }
}

export function* loadAdvertisingDetails() {
    try {
        const detailsId = yield select(detailsIdSelector);
        const response = yield call(AdvertisingService.getAdv, detailsId);
        yield put(actions.VIEW_ADV.success({ data: response.data }));
    } catch (e) {
        log.error(e);
        yield put(actions.VIEW_ADV.failed(null, createError(e)));
    }
}

export function* loadAdvertisingToEdit() {
    try {
        const { editing, open, id } = yield select(getFormStateSelector);
        const reviewStatusTypes  = yield select(reviewStatusTypesSelector);
        const users = yield select(usersSelector);
        if (editing && open && id) {
            const response = yield call(AdvertisingService.getAdvAsCreated, id);
            const responseAux = yield call(AdvertisingService.getAdv, id);
            const newResponse = { ...response.data, associations: [...responseAux.data.associations] };
            const advForm = formatAdvToEdit(newResponse);
            const statusTypes = reviewStatusTypes
                .filter((type) => type.name !== "")
                .map((type) => ({ value: type.id, label: type.name }));
            const initReviews = advForm.reviews?.length > 0 ?
                advForm.reviews.map((review) => ({
                    ...review,
                    reviewStatusType: statusTypes.find((sT) => sT.value === review.reviewStatusTypeID),
                    viewers: review?.viewerIds?.length > 0
                        ? users.filter(u => review?.viewerIds.includes(u.id)).map(u => ({...u, value: u.id, label:u.name}))
                        : []
                })) : [];
            const data = {
                ...advForm,
                reviews: initReviews
            };
            yield put(actions.TOGGLE_ADVERTISING_FORM.success({ data }));
        } else if (!id && editing) {
            log.error("No id has been assigned. Check loadAdvertisingToEdit saga");
            yield put(actions.TOGGLE_ADVERTISING_FORM.failed());
        } else {
            if (!id) {
                const filmRelease = yield select(selectedFilmRelease);
                if (filmRelease) {
                    const data = {
                        ...advFormDefaultValues,
                        filmRelease,
                    };
                    yield put(actions.TOGGLE_ADVERTISING_FORM.success({ data }));
                }
            }
        }
    } catch (e) {
        log.error(e);
        yield put(actions.TOGGLE_ADVERTISING_FORM.failed(null, createError(e)));
    }
}

export function* onReset() {
    try {
        yield put(actions.REFRESH_TABLE.send());
    } catch (error) {
        log.error(error);
    }
}

export function* createNewAdvFromExisting({ payload }) {
    try {
        const { id, refreshViewPage, isClone } = payload;
        const response = yield call(AdvertisingService.getAdvAsCreated, id);
        const responseAux = yield call(AdvertisingService.getAdv, id);
        const newResponse = { ...response.data, associations: [...responseAux.data.associations] };
        yield put(
            actions.TOGGLE_ADVERTISING_FORM.success({ data: fromExitingAdv(newResponse, refreshViewPage, isClone) })
        );
    } catch (e) {
        log.error(e);
        yield put(actions.TOGGLE_ADVERTISING_FORM.failed(null, createError(e)));
    }
}

export default [
    ...createSagasForBasicCall(actions),
    debounce(1000, actions.CHANGE_FORM.sendType, filterAdvertising),
    takeLatest(actions.REFRESH_TABLE.sendType, filterAdvertising),
    takeLatest(actions.CLEAR_FORM.type, onReset),
    takeLatest(actions.ADD_ADV.sendType, addAdvertising),
    takeLatest(actions.EDIT_ADV.sendType, editAdvertising),
    takeLatest(actions.VIEW_ADV.sendType, loadAdvertisingDetails),
    takeLatest(actions.TOGGLE_ADVERTISING_FORM.sendType, loadAdvertisingToEdit),
    takeLatest(actions.CREATE_ADV_FROM_EXISTING.type, createNewAdvFromExisting),
];
